const DISCOVER_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const DISCOVER_BASE_PATH = '/discover';

interface ParsedDiscoverArticle {
  id: string;
  slug?: string;
}

function parseDiscoverArticleRef(raw: string): ParsedDiscoverArticle | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const separatorIndex = trimmed.lastIndexOf('--');
  if (separatorIndex !== -1) {
    const id = trimmed.slice(separatorIndex + 2);
    if (DISCOVER_UUID_RE.test(id)) {
      const slug = trimmed.slice(0, separatorIndex).trim();
      return { id, slug: slug || undefined };
    }
    return null;
  }

  if (DISCOVER_UUID_RE.test(trimmed)) return { id: trimmed };
  return null;
}

export function parseDiscoverArticleId(raw: string): string | null {
  return parseDiscoverArticleRef(raw)?.id ?? null;
}

function normalizeSlug(slug: string | null | undefined): string | undefined {
  const normalized = slug?.trim();
  return normalized ? normalized : undefined;
}

export function discoverArticlePath(articleId: string, slug?: string | null): string {
  const parsed = parseDiscoverArticleRef(articleId);
  if (!parsed) {
    return `${DISCOVER_BASE_PATH}/${articleId}`;
  }
  const effectiveSlug = normalizeSlug(slug) ?? parsed.slug;
  if (!effectiveSlug) {
    return `${DISCOVER_BASE_PATH}/${parsed.id}`;
  }
  return `${DISCOVER_BASE_PATH}/${effectiveSlug}--${parsed.id}`;
}

export function discoverArticlePathFromSlugOrUuid(raw: string): string {
  const parsed = parseDiscoverArticleRef(raw);
  if (!parsed) return `${DISCOVER_BASE_PATH}/${raw}`;
  return discoverArticlePath(parsed.id, parsed.slug);
}
